/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, List, WhiteSpace, Badge, WingBlank } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import VisitorSection from "./VisitorSection";
import styled from "styled-components";
import { IoMdOpen } from "react-icons/io";
import * as selectors from "../../selectors";
import * as authAction from "../../actions/auth";
import * as walletAction from "../../actions/wallet";
import * as meAction from "../../actions/me";
import * as profileAction from "../../actions/profile";
import * as userSelectors from "../../selectors/user";
import * as walletSelectors from "../../selectors/wallet";
import { intl } from "../../services/intlGlobalProvider";
import Helper from "../../utils/Helper";
import LoadingIndicator from "../../components/LoadingIndicator";
import Color from "../../utils/Color";
import "./index.css";

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledHeaderTopContainer = styled.div`
  color: white;
  width: 100%;
  background-image: url(${require("../../assets/profile_top_banner.png")});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: -15%;
`;

const StyledHeaderNameContainer = styled.span`
  margin-top: 15%;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledHeaderName = styled.span`
  font-size: 1.4em;
  font-weight: bold;
`;

const StyledHeaderPoint = styled.span`
  font-size: 0.9em;
  margin-bottom: 25px;
`;

const StyledWalletTotalContainer = styled.div`
  display: flex;
  overflow-x: hidden;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  line-height: 1.8em;
  margin-bottom: 22%;
`;

const StyledCurrency = styled.span`
  font-size: 0.9em;
`;

const StyledWalletValue = styled.span`
  margin-left: 15px;
  font-size: 1.8em;
  font-weight: bold;
`;

const StyledHeaderTopContentContainer = styled.div`
  color: black;
  width: 85%;
  padding: 13px 0;
  border-radius: 8px;
  background: white;
  box-shadow: 5px 6px 6px -5px grey;
  display: flex;
  overflow-x: hidden;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
`;

const StyledHeaderTopContentIcon = styled.div`
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledViewAllOrderBtn = styled.div`
  color: grey;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
`;

const StyledFooterContainer = styled.div`
  padding: 5px 0;
  color: grey;
  font-size: 0.9em;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const Item = List.Item;

const Alert = Modal.alert;

const Prompt = Modal.prompt;

class ProfilePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      versionPressed: 0
    };
  }

  componentDidMount() {
    const { authToken } = this.props;
    this.configureNavBar();

    if (authToken) {
      this.fetchMeData();
      this.fetchProfileData();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.authToken !== this.props.authToken) {
      if (nextProps.authToken) {
        this.fetchMeData();
        this.fetchProfileData();
      }
    }

    if (this.props.updateProfileStatus !== nextProps.updateProfileStatus) {
      if (nextProps.updateProfileStatus) {
        // this.editNameDialog.dismiss();
        this.fetchMeData();
        this.fetchProfileData();
      }
    }
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="profile.title"
        defaultMessage="Profile"
        description="Profile title"
      />
    );

    navbarConfig(navTitle, <div />);
    showNavbar(true);
    showTabbar(true);
  };

  fetchMeData = () => {
    const { getMeData } = this.props;

    getMeData();
  };

  fetchProfileData = () => {
    const { getMyWalletDetailRequest } = this.props;

    getMyWalletDetailRequest();
  };

  showConfirmLogoutDialog = () => {
    const { logoutAccount } = this.props;

    Alert(
      intl.formatMessage({
        id: "auth.logout",
        defaultMessage: "Logout"
      }),
      intl.formatMessage({
        id: "auth.confirm.logout",
        defaultMessage: "Are you sure?"
      }),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: () => {
            logoutAccount && logoutAccount();
          }
        }
      ]
    );
  };

  showEditDisplayNameDialog = () => {
    const { meData } = this.props;
    const username = userSelectors.getUserName(meData);

    Prompt(
      intl.formatMessage({
        id: "profile.edit.name.title",
        defaultMessage: "Change Display Name"
      }),
      intl.formatMessage({
        id: "profile.edit.name.description",
        defaultMessage: "Enter your desired name?"
      }),
      [
        {
          text: intl.formatMessage({
            id: "app.cancel",
            defaultMessage: "Cancel"
          })
        },
        {
          text: intl.formatMessage({
            id: "app.ok",
            defaultMessage: "OK"
          }),
          onPress: nameValue => {
            this.onPressUpdateName(nameValue);
          }
        }
      ],
      "default",
      username
    );
  };

  onPressUpdateName = nameValue => {
    const { updateProfileData } = this.props;

    const submitData = {
      display_name: nameValue
    };

    updateProfileData(submitData);
  };

  onPressVersionText = () => {
    const { versionPressed } = this.state;

    this.setState({
      versionPressed: versionPressed + 1
    });

    if (versionPressed === 10) {
      Alert(
        "",
        "Powered by Alpstein Software",
        [
          {
            text: "Cancel"
          },
          {
            text: "Visit Us",
            onPress: () => window.open("https://alpstein.my", "_blank")
          }
        ],
        { cancelable: false }
      );
      this.setState({ versionPressed: 0 });
    }
  };

  renderHeader = () => {
    const { history, walletItem, meData, orderIndicator } = this.props;
    const walletBalance = walletSelectors.getWalletBalance(walletItem);
    const walletCurrency = walletSelectors.getWalletCurrency(walletItem);
    const formattedWalletBalance = Helper.formatPriceNumber(walletBalance);

    const username = userSelectors.getUserName(meData);
    const pointBalance = userSelectors.getUserPointBalance(meData);

    return (
      <StyledHeaderContainer>
        <StyledHeaderTopContainer>
          <StyledHeaderNameContainer>
            <StyledHeaderName>{username}</StyledHeaderName>
            <WingBlank size="sm" />
            <IoMdOpen
              color="white"
              style={{ fontSize: "1em" }}
              onClick={() => this.showEditDisplayNameDialog()}
            />
          </StyledHeaderNameContainer>
          <StyledHeaderPoint
            className={"underline"}
            onClick={() => history.push("/shop/point/history")}
          >
            {pointBalance}{" "}
            <FormattedMessage
              id="profile.point.title"
              defaultMessage="Points"
              description="Profile Points Title"
            />{" "}
          </StyledHeaderPoint>
          <StyledWalletTotalContainer>
            <StyledCurrency>{walletCurrency}</StyledCurrency>
            <StyledWalletValue>{formattedWalletBalance}</StyledWalletValue>
          </StyledWalletTotalContainer>
        </StyledHeaderTopContainer>
        <StyledHeaderTopContentContainer>
          <StyledHeaderTopContentIcon
            className={"opacity"}
            onClick={() => history.push("/shop/top-up")}
          >
            <img
              src={require("../../assets/icons/e-wallet.png")}
              style={{ width: "4.5em" }}
            />
            <WhiteSpace size={"md"} />
            <FormattedMessage
              id="profile.topup.wallet.title"
              defaultMessage="Top Up e-wallet"
              description="Profile Top Up E-wallet Title"
            />
          </StyledHeaderTopContentIcon>
          <div style={{ width: "4em" }} />
          <StyledHeaderTopContentIcon
            className={"opacity"}
            onClick={() => history.push("/shop/payment/history")}
          >
            <img
              src={require("../../assets/icons/history.png")}
              style={{ width: "4.5em" }}
            />
            <WhiteSpace size={"md"} />
            <FormattedMessage
              id="profile.payment.history.title"
              defaultMessage="Payment History"
              description="Profile Payment History Title"
            />
          </StyledHeaderTopContentIcon>
        </StyledHeaderTopContentContainer>
        <WhiteSpace size={"lg"} />
        <List className={"profile-listing"}>
          <Item
            extra={
              <StyledViewAllOrderBtn>
                <FormattedMessage
                  id="profile.myorder.viewall.title"
                  defaultMessage="View all orders"
                  description="Profile view all orders Title"
                />
                {orderIndicator ? (
                  <Badge
                    dot
                    style={{
                      marginLeft: 8,
                      backgroundColor: Color.highlightRedTextColor
                    }}
                  />
                ) : (
                  false
                )}
              </StyledViewAllOrderBtn>
            }
            style={{ cursor: "pointer" }}
            arrow="horizontal"
            onClick={() => history.push("/shop/order")}
          >
            <FormattedMessage
              id="profile.myorder.title"
              defaultMessage="My Order"
              description="Profile My Order Title"
            />
          </Item>
          <Item
            style={{ cursor: "pointer" }}
            arrow="horizontal"
            onClick={() => history.push("/shop/queue")}
          >
            <FormattedMessage
              id="profile.food.queue.title"
              defaultMessage="Food Queue"
              description="Profile Food Queue Title"
            />
          </Item>
        </List>
        <WhiteSpace size={"md"} />
      </StyledHeaderContainer>
    );
  };

  renderFooter = () => {
    return (
      <StyledFooterContainer onClick={() => this.onPressVersionText()}>
        {process.env.REACT_APP_VERSION}
      </StyledFooterContainer>
    );
  };

  render() {
    const {
      history,
      authToken,
      loading,
      walletLoading,
      updateProfileLoading
    } = this.props;

    return (
      <StyledContainer>
        {loading || walletLoading || updateProfileLoading ? (
          <LoadingIndicator />
        ) : null}
        {authToken ? (
          <List
            className={"profile-listing"}
            renderHeader={this.renderHeader}
            renderFooter={this.renderFooter}
          >
            <Item
              extra={
                <img
                  src={require("../../assets/icons/qr-code.png")}
                  style={{ width: "1.1em", height: "1.1em" }}
                />
              }
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/shop/self/qr-code")}
            >
              <FormattedMessage
                id="profile.my.qrcode.title"
                defaultMessage="My QR Code"
                description="My QR Code Title"
              />
            </Item>
            <Item
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/shop/profile/details")}
            >
              <FormattedMessage
                id="profile.details.title"
                defaultMessage="My Details"
                description="Profile My Details Title"
              />
            </Item>
            <Item
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/shop/favourite")}
            >
              <FormattedMessage
                id="profile.favourite.title"
                defaultMessage="My Favourite"
                description="Profile My Favourite Title"
              />
            </Item>
            <Item
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/shop/social")}
            >
              <FormattedMessage
                id="profile.social.title"
                defaultMessage="Linked Accounts"
                description="Linked Account Title"
              />
            </Item>
            <Item
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/shop/invite-friends")}
            >
              <FormattedMessage
                id="profile.invite.friends.title"
                defaultMessage="Invite Friends"
                description="Profile Invite Friends Title"
              />
            </Item>
            <Item
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/language")}
            >
              <FormattedMessage
                id="profile.language.title"
                defaultMessage="Language"
                description="Profile Language Title"
              />
            </Item>
            <Item
              style={{ cursor: "pointer" }}
              arrow="horizontal"
              onClick={() => history.push("/shop/terms-and-conditions")}
            >
              <FormattedMessage
                id="profile.term.and.condition"
                defaultMessage="Terms And Conditions"
                description="Terms And Conditions Title"
              />
            </Item>
            <WhiteSpace size={"md"} />
            <Item
              style={{ cursor: "pointer" }}
              className={"profile-listing-logout-item"}
              onClick={() => this.showConfirmLogoutDialog()}
            >
              <FormattedMessage
                id="profile.logout.title"
                defaultMessage="Logout"
                description="Profile Logout Title"
              />
            </Item>
          </List>
        ) : (
          <VisitorSection {...this.props} />
        )}
      </StyledContainer>
    );
  }
}

ProfilePage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  authToken: PropTypes.string,
  orderIndicator: PropTypes.bool,
  walletItem: PropTypes.object,
  walletLoading: PropTypes.bool,
  meData: PropTypes.object,
  updateProfileStatus: PropTypes.bool,
  updateProfileLoading: PropTypes.bool,
  loading: PropTypes.bool,
  logoutAccount: PropTypes.func,
  getMyWalletDetailRequest: PropTypes.func,
  getMeData: PropTypes.func,
  updateProfileData: PropTypes.func
};

function mapStateToProps(state) {
  return {
    authToken: selectors.getAuthToken(state),
    orderIndicator: selectors.getOrderIndicatorStatus(state),
    walletItem: selectors.getMyWalletItem(state),
    walletLoading: selectors.getMyWalletLoading(state),
    meData: selectors.getMeData(state),
    updateProfileStatus: selectors.getUpdateProfileStatus(state),
    updateProfileLoading: selectors.getUpdateProfileLoading(state),
    loading: selectors.getMeLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logoutAccount: () => dispatch(authAction.logoutAccountRequest()),
    getMyWalletDetailRequest: () =>
      dispatch(walletAction.getMyWalletDetailRequest()),
    getMeData: () => dispatch(meAction.getMeDataRequest()),
    updateProfileData: profileData =>
      dispatch(profileAction.updateProfileDataRequest(profileData))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProfilePage)
);



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/index.js